<ngx-spinner
bdColor="rgba(0, 0, 0, 0.8)"
size="medium"
color="#0d4c73"
type="ball-clip-rotate-multiple"
>
<p style="font-size: 20px; color: white">Cargando...</p>
</ngx-spinner>
<router-outlet></router-outlet>